import { render, staticRenderFns } from "./ApprovalFormConfig.vue?vue&type=template&id=055a7a86"
import script from "./ApprovalFormConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalFormConfig.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFormConfig.vue?vue&type=style&index=0&id=055a7a86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports